<template>
  <section class="member-search">
    <el-tabs v-model="activeSearchType" stretch>
      <el-tab-pane label="快速搜尋" name="short">
        <div v-loading="tryingGetMember" element-loading-background="rgba(255,255,255,0.7)" class="search-box__wrapper">
          <el-form ref="searchFormByShort" class="el-form-item--normal-margin el-form-item--white-bg search-box" :model="filterData" @submit.native.prevent>
            <el-form-item>
              <span slot="label">快速查詢客戶 <span class="text-muted-0">(請輸入電話末三碼或寵物名稱)</span></span>
              <el-autocomplete ref="autocomplete" v-model="filterData.search" style="width: 100%" :fetch-suggestions="searchQuery" :trigger-on-focus="false" @select="selectMember">
                <template v-slot="{ item }">
                  <span class="info-line-box">
                    <span v-if="searchNone" class="add-box"> 查無會員，立刻新增會員 </span>
                    <template v-else-if="!isString">
                      <span class="info-line content">{{ item.phoneNumber }}</span>
                      <span class="info-line title">{{ item.fullName }}</span>
                      <span class="info-line more-content">{{ memberPets(item) }}</span>
                    </template>
                    <template v-else>
                      <span class="info-line content">{{ getSinglePetName(item) }}</span>
                      <span class="info-line title">{{ item.fullName }}</span>
                      <span class="info-line more-content">{{ item.phoneNumber }}</span>
                    </template>
                  </span>
                </template>
              </el-autocomplete>
            </el-form-item>
            <el-button class="is-round is-fullwidth isPrimaryOutLine" :loading="tryingGetMember" @click="searchQueryByBtn">查詢</el-button>
          </el-form>
        </div>
      </el-tab-pane>
      <el-tab-pane label="新增客戶" name="phone">
        <div class="search-box__wrapper">
          <el-form ref="searchFormByPhone" class="el-form-item--normal-margin el-form-item--white-bg search-box" :model="searchData" :rules="searchRules">
            <el-form-item prop="phoneNumber">
              <span slot="label">新增客戶 </span>
              <el-input v-model.trim="searchData.phoneNumber" placeholder="請輸入手機號碼" @keyup.native.enter="createMemberByPhone">
                <CountryCodePicker slot="prepend" v-model="searchData.phoneCode" />
              </el-input>
            </el-form-item>
            <el-button class="is-round is-fullwidth isPrimaryOutLine" :loading="tryingGetMember" @click="createMemberByPhone">新增</el-button>
          </el-form>
        </div>
      </el-tab-pane>
    </el-tabs>
  </section>
</template>

<script>
import CountryCodePicker from '@/src/components/CountryCodePicker.vue'
import { runMemberSearchQuery, triggerMemberSearchByBtn } from '@utils/memberShortSearch'
export default {
  name: 'MemberSearchPartial',
  components: {
    CountryCodePicker,
  },
  props: {},
  data() {
    return {
      activeSearchType: 'short',
      filterData: {
        search: '',
      },
      searchData: {
        phoneCode: '+886',
        phoneNumber: '',
      },
      searchNone: false,
      tryingGetMember: false,
      isNewMember: false,
    }
  },
  computed: {
    searchRules() {
      const isTaiwan = this.searchData.phoneCode === '+886'
      return {
        phoneNumber: [
          {
            pattern: isTaiwan ? /^09\d{8}$/ : '',
            message: '格式請符合 09XXXXXXXX',
            trigger: 'blur',
          },
        ],
      }
    },
    isString() {
      const result = parseInt(this.filterData.search)
      return !result
    },
  },
  methods: {
    async searchQuery(string, cb) {
      await runMemberSearchQuery(this, string, cb)
    },
    searchQueryByBtn() {
      triggerMemberSearchByBtn(this)
    },
    memberPets(item) {
      if (item.value !== '查無會員，立刻新增會員') {
        const petNames = item.pets.map((pet) => pet.name)
        return petNames.join('，')
      }

      return ''
    },
    getSinglePetName(item) {
      const petNames = item.pets.map((pet) => pet.name.toLowerCase())
      const index = petNames.findIndex((name) => name.includes(this.filterData.search.toLowerCase()))

      return index !== -1 ? item.pets[index].name : ''
    },
    async selectMember(item) {
      this.tryingGetMember = true
      try {
        if (item.value && item.value !== '查無會員，立刻新增會員') {
          await this.handleMemberFound(item.id)
        }
        if (item.value === '查無會員，立刻新增會員') {
          // 如果輸入的是純數字，將其填入新增手機欄位
          if (!this.isString) {
            this.searchData.phoneNumber = this.filterData.search
          }

          this.filterData.search = ''
          this.activeSearchType = 'phone'
          this.$refs.autocomplete.$refs.suggestions.showPopper = false
          // 這裡不直接 emit，讓使用者在「新增客戶」分頁點擊按鈕後才執行 findByPhone 檢查
        }
      } finally {
        this.tryingGetMember = false
      }
    },
    async handleMemberFound(memberId) {
      const member = await this.$store.dispatch('member/fetchSingleShort', { memberId })
      this.$store.commit('hotel/order/SET_MEMBER', member)
      this.nextStep()
    },
    async createMemberByPhone() {
      if (this.$refs.searchFormByPhone) {
        try {
          await this.$refs.searchFormByPhone.validate()
        } catch (error) {
          return
        }
      }
      this.tryingGetMember = true
      try {
        const member = await this.$store.dispatch('member/findByPhone', {
          phoneCode: this.searchData.phoneCode,
          phoneNumber: this.searchData.phoneNumber,
        })
        if (member) {
          await this.handleMemberFound(member.id)
          this.$message.success('偵測到重複手機號碼，已自動為您帶入會員資料')
        }
      } catch (error) {
        if (error.code === 404 && !error.data) {
          this.$message.info('確認無此客戶，請繼續新增會員流程')
          this.$emit('open-member-create')
          return
        }
        console.error('Check phone failed:', error)
        this.$message.error('查詢會員狀態失敗，請稍後再試')
      } finally {
        this.tryingGetMember = false
      }
    },
    nextStep() {
      this.$emit('next-step', 2)
    },
  },
}
</script>

<style lang="scss" scoped>
.member-search {
  .search-box__wrapper {
    padding: 20px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  }

  .info-line-box {
    display: flex;
    flex-direction: column;
    line-height: 1.6;
  }

  .info-line.title {
    font-weight: 600;
  }

  .info-line.more-content {
    color: #909399;
  }

  .add-box {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: #ea6a2a;
  }
}

::v-deep .el-tabs .el-tabs__item {
  font-size: 1.3rem;
}
</style>
